<template>
  <div class="mm">
    <div style="margin-bottom: 100px;">
      <p style="text-align: center;font-weight: 800;">
        <span style="font-size:22px;">预约上门取车导办检车说明</span>
      </p>

      <p style="text-indent: 37px; text-align: justify; line-height: 2em;">
        <span style="font-size:16px;"><span style="color:#1989FA;font-size:17px;">取还车范围：</span>太和街道、下关街道、大理经济技术开发区、满江街道、凤仪镇。如超出范围费用需另算。</span>
      </p>

      <div style="font-size:17px;;color:#1989FA;text-indent: 37px; text-align: justify;">
        收费标准：
      </div>

      <div v-for="(item,index) in businessList" :key="index">
        <div style="text-indent: 37px; text-align: justify; line-height: 2em;">
           <span style="font-size:16px;">
              <span style="font-weight: 900">{{ item.stationName }}：</span>
             <!--              <span v-if="item.stationId == 2">
                          车辆检测费原价310元/次。<span style="color: red">特价车辆检测费{{item.vehicleFee}}元/次，取还车费{{item.doorServiceFee}}元/次。</span><br>
                          <span style="font-size: 14px;color: red;">活动时间：2023年09月29日-2023年10月06日。<br>
                          优惠价格可预约检车时间截至2023年10月31日。</span>
                        </span>-->
            <span>
              车辆检测费{{item.vehicleFee}}元/次
            </span>
              <span v-if="item.inspectionServiceFee > 0">，人工导办检测费{{item.inspectionServiceFee}}元/次</span>
              <span v-if="item.doorServiceFee > 0">，取还车费{{item.doorServiceFee}}元/次。</span>
          </span>
        </div>
      </div>

      <br/>

      <div style="font-size:17px;color:#1989FA;text-indent: 37px; text-align: justify;">
        在线退订：
      </div>
      <div style="text-indent: 37px; text-align: justify; line-height: 2em;">
        <!--      <span style="font-size:16px;">下单后如需退单将收取平台预约服务费的100%作为手续费，车辆检测费全额退款。审核通过后的订单不支持退单。</span>-->
        <span style="font-size:16px;">如下单后因其他原因需要退订的，在核销订单前均可通过在线退订功能（联系客服人员完成退订）进行自助退订，车辆检测费可全额退款。</span>
      </div>
      <br/>

      <div style="font-size:17px;color:#1989FA;text-indent: 37px; text-align: justify;">
        温馨提示：
      </div>
      <div style="text-indent: 37px; text-align: justify; line-height: 2em;">
        <span style="font-size:16px;">车型仅限7座及7座以下，办理代驾检车业务需要提前一天预约。</span>
      </div>
      <br/>

      <div style="font-size:17px;;color:#1989FA;text-indent: 37px; text-align: justify;">
        站场介绍：
      </div>

      <div style="font-size:17px;font-weight: 900;text-align: center;margin: 15px 0px 6px 0px;">
        金益汽车检测站（凤仪）
      </div>
      <div style="margin-bottom: 16px;">
        <van-image
            width="100%"
            height="250"
            fit="cover"
            src="/images/square.png"
        />
        <div style="font-size:15px;text-align: center;">外检广场</div>
      </div>
      <div style="margin-bottom: 16px;">
        <van-image
            width="100%"
            height="250"
            fit="cover"
            src="/images/vehicle_inspection.png"
        />
        <div style="font-size:15px;text-align: center;">车辆检测</div>
      </div>
      <div style="margin-bottom: 16px;">
        <van-image
            width="100%"
            height="250"
            fit="cover"
            src="/images/hall.png"
        />
        <div style="font-size:15px;text-align: center;">报检大厅</div>
      </div>


      <div style="font-size:17px;font-weight: 900;text-align: center;margin: 20px 0px 6px 0px;">
        金洱汽车检测站（北区）
      </div>
      <div style="margin-bottom: 16px;">
        <van-image
            width="100%"
            height="250"
            fit="cover"
            src="/images/square_bei.png"
        />
        <div style="font-size:15px;text-align: center;">外检广场</div>
      </div>
      <div style="margin-bottom: 16px;">
        <van-image
            width="100%"
            height="250"
            fit="cover"
            src="/images/bei2.png"
        />
        <div style="font-size:15px;text-align: center;">安检、环检区</div>
      </div>
      <div style="margin-bottom: 16px;">
        <van-image
            width="100%"
            height="250"
            fit="cover"
            src="/images/bei3.png"
        />
        <div style="font-size:15px;text-align: center;">报检大厅</div>
      </div>
    </div>

    <div style="position: fixed;bottom: 30px;left: 20px;right: 20px;">
      <van-button color="#1989FA" block>我已知晓</van-button>
    </div>
  </div>
</template>

<script>
import carInspectionBusiness from "@/api/carInspectionBusiness";

export default {
  name: "appointmentTips",
  props: {
    tipsData: {
      type: Object,
    }
  },
  data() {
    return {
      businessList: [],
      inspectionServiceDiscount: 0
    }
  },
  created() {
    this.getBusinessListByType()
  },
  methods:{
    getBusinessListByType(){
      carInspectionBusiness.getBusinessListByType({
        'businessType': '上门代检',
      }).then(res => {
        this.businessList = res
        for(let i=0;i<res.length;i++){
          let data = res[i]
          if(data.inspectionServiceDiscount > 0){
            this.inspectionServiceDiscount = data.inspectionServiceDiscount
            return
          }
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    }
  }

}
</script>

<style scoped>
.mm {
  background: #ffffff;
  padding: 13px;
}
</style>
